import { Stack } from '@mui/material'
import React from 'react'
import PersonalDetails from '../admin/personnel/addNewEmployee/PersonalDetails'
import ContactInfo from '../admin/personnel/addNewEmployee/ContactInfo'
import NextOfKin from '../admin/personnel/addNewEmployee/NextOfKin'

// Address has its own step (with the five-year history), so only the
// identity, contact and emergency-contact cards live here.
const PersonalInfo = ({ formValues, setFormValues }) => (
  <Stack gap={2}>
    <PersonalDetails
      formValues={formValues}
      setFormValues={setFormValues}
      isSelf={true}
    />
    <ContactInfo formValues={formValues} setFormValues={setFormValues} />
    <NextOfKin formValues={formValues} setFormValues={setFormValues} />
  </Stack>
)

export default PersonalInfo
